import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _Icon;

import React from 'react';
import styled from 'styled-components';
import Icon from '@ant-design/icons'; // @ts-ignore

import { ReactComponent as LocationIcon } from '@kargotech/tms-common/Assets/Icons/location.svg';
var Location = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.isActive ? props.theme.colors.primary : props.theme.colors.dark;
});
var Marker = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: white;\n  border-radius: 100%;\n  border: 2px solid ", ";\n  box-shadow: 0 0 3px ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: 16px;\n  font-weight: bold;\n  height: ", ";\n  justify-content: center;\n  padding: 3px;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  transition: box-shadow 1s;\n  width: ", ";\n  z-index: 4;\n  &:hover {\n    box-shadow: 0 0 7px #04070C;\n  }\n"])), function (props) {
  return props.theme.colors[props.borderColor];
}, function (props) {
  return props.theme.colors[props.borderColor];
}, function (props) {
  return props.theme.colors[props.valueColor];
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

function generateMarkerColorPreset(isActive) {
  return isActive ? 'primary' : 'dark';
}

var LocationMarkerRounded = function LocationMarkerRounded(_ref) {
  var children = _ref.children,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30px' : _ref$height,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$markerProps = _ref.markerProps,
      markerProps = _ref$markerProps === void 0 ? {
    borderColor: '',
    valueColor: ''
  } : _ref$markerProps,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function (e) {
    return e;
  } : _ref$onBlur,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function (e) {
    return e;
  } : _ref$onClick,
      _ref$onMouseOut = _ref.onMouseOut,
      onMouseOut = _ref$onMouseOut === void 0 ? function (e) {
    return e;
  } : _ref$onMouseOut,
      _ref$onMouseOver = _ref.onMouseOver,
      onMouseOver = _ref$onMouseOver === void 0 ? function (e) {
    return e;
  } : _ref$onMouseOver,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '30px' : _ref$width;
  var borderColor = markerProps.borderColor,
      valueColor = markerProps.valueColor;

  if (!borderColor) {
    /* eslint-disable-next-line no-param-reassign */
    markerProps.borderColor = generateMarkerColorPreset(isActive);
  }

  if (!valueColor) {
    /* eslint-disable-next-line no-param-reassign */
    markerProps.valueColor = generateMarkerColorPreset(isActive);
  }

  return /*#__PURE__*/React.createElement(Marker, _extends({
    height: height,
    onBlur: onBlur,
    onClick: onClick,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    width: width
  }, markerProps), children || /*#__PURE__*/React.createElement(Location, {
    isActive: isActive
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    component: LocationIcon
  }))));
};

export default LocationMarkerRounded;